var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bx--btn bx--skeleton",class:{ 'bx--btn--sm': _vm.small },attrs:{"disabled":"","type":"button"}})}
var staticRenderFns = []

export { render, staticRenderFns }